import { Pipe, PipeTransform } from '@angular/core';

import { format } from "date-fns";

import { RouteEvent } from '@commons/models/domain/RouteEvent';
import { sortRoutesByDate } from '@src/app/utils/date';
import { BusinessEvent } from '@commons/models/domain/BusinessEvent';

export interface IGroupObjArr<T> {
  date: string;
  routes: T[];
  id: number;
  events?: BusinessEvent[];
}

@Pipe({
  name: 'groupRoutesByDate',
  standalone: true
})
export class GroupRoutesByDatePipe implements PipeTransform {

  transform(route?: RouteEvent[]): IGroupObjArr<any>[] {
    if (!route?.length) {
      return [];
    }

    return sortRoutesByDate(
      route.reduce((prev: IGroupObjArr<any>[], curr: RouteEvent, index: number): IGroupObjArr<any>[] => {
        const currentDateRoute = format(new Date(curr.St || curr.En), 'MM-d-yyyy');
        const findPrev = prev.some(el => el.date === currentDateRoute);

        if (!findPrev) {
          const data = {
            id: index + 1,
            date: currentDateRoute,
            routes: route
              .filter(item => format(new Date(item.St || item.En), 'MM-d-yyyy') === currentDateRoute)
              .map(item => ({...item, Points: []})),
          };
          prev.push(data);
        }

        return prev;
      }, []),
    );
  }

}
